import React, { useState, useEffect, createContext } from "react";
import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";

export const UserContext = createContext(null);

const Page    = styled.div`display:flex;flex-direction:column;min-height:100vh;`;
const Content = styled.div`flex:1;max-width:1200px;margin:20px auto;padding:0 16px;`;
const SidebarLayout = styled.div`
  display:flex;gap:24px;
  @media(max-width:1000px){display:block;}`;
const Sidebar = styled.nav`
  width:220px;flex-shrink:0;
  background:#fff;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.05);
  padding:24px;margin-bottom:24px;
  a{display:block;margin-bottom:12px;color:#333;text-decoration:none;font-weight:500;
    &:hover{color:#1B6392;}
    &.active{color:#1B6392;font-weight:600;}
  }
`;

export default function ProfileLayout() {
    const [userInfo, setUserInfo] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const token = sessionStorage.getItem("accessToken");
        if (!token) return navigate("/");

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/user/user-info`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then(({ data }) => setUserInfo(data))
            .catch(() => navigate("/"));
    }, [navigate]);

    if (!userInfo) {
        return (
            <Page>
                <Content>Загрузка...</Content>
            </Page>
        );
    }

    return (
        <UserContext.Provider value={userInfo}>
            <Page>

                <Content>
                    <SidebarLayout>
                        <Sidebar>
                            <Link to="/profile" className={location.pathname==="/profile"?"active":""}>
                                Личный кабинет
                            </Link>
                            <Link to="/profile/orders" className={location.pathname.startsWith("/profile/orders")?"active":""}>
                                История заказов
                            </Link>
                            <Link to="/profile/cart" className={location.pathname==="/profile/cart"?"active":""}>
                                Корзина покупок
                            </Link>
                            <Link to="/profile/settings" className={location.pathname.startsWith("/profile/settings")?"active":""}>
                                Настройки
                            </Link>
                            <Link to="/logout">Выход</Link>
                        </Sidebar>

                        <Outlet />
                    </SidebarLayout>
                </Content>

            </Page>
        </UserContext.Provider>
    );
}
